import React, { useState, useEffect, useRef } from "react";
import { ReactComponent as EditIcon } from "../../img/editicon.svg";
import { ReactComponent as TrashIcon } from "../../img/trashicon.svg";
import {instance2} from '../../utils/axiosInstance'
import { ReactComponent as VerticalLine } from '../../img/verticalline.svg'
import { ReactComponent as MagnificationLogo } from '../../img/magnificationlensicon.svg'
import { ReactComponent as BackButton } from "../../img/bacbuttonicon.svg";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "src/components/numberingformat";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/shadcn/dialog";

export default function InputDapur() {
    const navigate = useNavigate();
  const locationId = localStorage?.getItem("locationId")
  const [formData, setFormData] = useState({
    name: "",
    location_id: "",
    description: "",
    admin_id: "",
  });
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState("");
  const [userId, setUserId] = useState("");
  const [location, setLocation] = useState([]); // Storage locations
  const [loading, setLoading] = useState(true); // Loading state
  const [user, setUser] = useState("");
  // Modal States
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editRowData, setEditRowData] = useState(null);
  const [isDropdownModalOpen, setIsDropdownModalOpen] = useState(false);
  const [modalSearchTerm, setModalSearchTerm] = useState(""); // Modal-specific search term
  const [modalFilteredLocations, setModalFilteredLocations] = useState([]); // Modal-specific filtered locations
    const [searchQuery, setSearchQuery] = useState(""); // State for search input
  

  useEffect(() => {
    setModalFilteredLocations(
      location.filter((loc) =>
        loc.name.toLowerCase().includes(modalSearchTerm.toLowerCase())
      )
    );
  }, [modalSearchTerm, location]);
  
  const dropdownRef = useRef(null); // Ref to track dropdown

  const filteredLocations = location.filter((loc) =>
    loc.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
  useEffect(() => {
    const storedUser = localStorage.getItem('userAuthentication');
    if (storedUser) {
      setUser(storedUser);
    }
    const storedUserId = localStorage.getItem("userId");
    if (storedUserId) {
      setUserId(parseInt(storedUserId, 10)); // Ensure userId is an integer
      setFormData((prev) => ({
        ...prev,
        admin_id: user //parseInt(storedUserId, 10), // Automatically update admin_id
      }));
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError(null);
    setSuccessMessage("");
  
    try {
      const response = await instance2.post("kitchen", formData);
  
      setSuccessMessage("Kitchen created successfully!");
      setFormData({
        name: "",
        location_id: "",
        description: "",
        admin_id: user, // Reset admin_id to current user
      });
    } catch (err) {
      setError(err.response?.data?.message || "Failed to create Kitchen. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };
  

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await instance2.get("location"); // Use instance2 for the API call
  
        const locationData = response.data; // Access the data property from Axios response
  
        setLocation(
          locationData.map((loc) => ({
            id: loc.id,
            name: loc.location_name,
            code: loc.code,
          }))
        );
      } catch (err) {
        console.error("Failed to fetch locations", err);
        setError(err.response?.data?.message || "Failed to fetch storage locations");
      } finally {
        setLoading(false);
      }
    };
  
    fetchLocation();
  }, []);
  

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

 const fetchKitchenData = async () => {
    try {
      let response;
      if (roleId === 1) {
        response = await instance2.get("/kitchen");
      } else {
        response = await instance2.get(`/kitchen/location/${locationId}`);
      }
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  // ✅ Call fetch function on mount
  useEffect(() => {
    fetchKitchenData();
  }, []);

  const handleSort = (key) => {
    const newDirection =
      sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    const sortedData = [...data].sort((a, b) => {
      if (a[key] < b[key]) return newDirection === 'asc' ? -1 : 1;
      if (a[key] > b[key]) return newDirection === 'asc' ? 1 : -1;
      return 0;
    });
    setData(sortedData);
    setSortConfig({ key, direction: newDirection });
  };

  const getSortArrow = (key) => {
    if (sortConfig.key === key) {
      return sortConfig.direction === 'asc' ? '▲' : '▼';
    }
    return '';
  };

  const handleModalChange = (e) => {
    const { name, value } = e.target;
    setEditRowData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClick = (row) => {
    setEditRowData({
      id: row.id, // Ensure `id` is passed
      kitchen_name: row.kitchen_name || row.name,
      description: row.description,
      kitchen_pack: row.kitchen_pack,
      kitchen_head: row.kitchen_head,
      phone: row.phone,
      location_id: row.location_id,
      address: row.address,
    });
  
    const selectedLocation = location.find((loc) => loc.id === row.location_id);
    setModalSearchTerm(selectedLocation ? selectedLocation.name : "");
  
    setIsModalOpen(true);
  };
  
  
const handleUpdate = async () => {
  const payload = {
    name: editRowData.kitchen_name,
    location_id: editRowData.location_id,
    description: editRowData.description,
    kitchen_pack: editRowData.kitchen_pack,
    kitchen_head: editRowData.kitchen_head,
    phone: editRowData.phone,
    address: editRowData.address,
    admin_id: localStorage.getItem("userAuthentication") || ""
  };

  try {
    const response = await instance2.put(`kitchen/${editRowData.id}`, payload);

    if (response.status === "OK") {
      //alert('Data updated successfully!');
      fetchKitchenData();
      setIsModalOpen(false); // Close modal on success
      // Optionally refresh table data
    }
  } catch (error) {
    console.error('Error updating data:', error);
    alert('Failed to update data. Please try again.');
  }
};
  
useEffect(() => {
  const fetchLocation = async () => {
    try {
      const response = await instance2.get("location"); // Use instance2 for the API call

      const locationData = response.data; // Access the data property from Axios response

      setLocation(
        locationData.map((loc) => ({
          id: loc.id,
          name: loc.location_name,
          code: loc.code,
        }))
      );
    } catch (err) {
      console.error("Failed to fetch locations", err);
      setError(err.response?.data?.message || "Failed to fetch storage locations");
    } finally {
      setLoading(false);
    }
  };

  fetchLocation();
}, []);


  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this data? This action cannot be undone."
    );
  
    if (!confirmDelete) {
      return; // Exit if the user cancels the deletion
    }
  
    try {
      const response = await instance2.delete(`kitchen/${id}`); // Replace `kitchen` with your endpoint
  
      if (response.status === "OK") {
        alert("Data deleted successfully!");
        // Remove the deleted row from the table
        setData((prevData) => prevData.filter((item) => item.id !== id));
      } else {
        alert("Failed to delete data. Please try again.");
      }
    } catch (error) {
      console.error("Error deleting data:", error);
      alert("An error occurred while deleting the data.");
    }
  };
  

  const filteredData = data.filter((item) => {
    const searchValue = searchQuery;
    return (
      (item.kitchen_name?.toLowerCase().includes(searchValue.toLowerCase()) || false) ||
      (item.location_name?.toLowerCase().includes(searchValue) || false) ||
      (item.name?.toLowerCase().includes(searchValue) || false)
    );
  });

const roleId = parseInt(localStorage.getItem('roleId'),10); 


      const [currentPage, setCurrentPage] = useState(1);
         const itemsPerPage = 10;
       
         const totalPages = Math.ceil(filteredData.length / itemsPerPage);
         const paginatedData = filteredData.slice(
           (currentPage - 1) * itemsPerPage,
           currentPage * itemsPerPage
         );
       
         const handlePreviousPage = () => {
           if (currentPage > 1) setCurrentPage(currentPage - 1);
         };
       
         const handleNextPage = () => {
           if (currentPage < totalPages) setCurrentPage(currentPage + 1);
         };
       
         // Determine which page numbers to show
         let pageNumbers = [];
         const maxVisiblePages = 5;
       
         if (totalPages <= maxVisiblePages) {
           pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
         } else {
           if (currentPage <= 3) {
             // Near the beginning
             pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
           } else if (currentPage >= totalPages - 2) {
             // Near the end
             pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
           } else {
             // In the middle
             pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
           }
         }

         // --- STATE ---
         const [confirmOpen, setConfirmOpen] = useState(false);
         const [resultOpen, setResultOpen] = useState(false);
         const [resultTitle, setResultTitle] = useState("");
         const [resultMsg, setResultMsg] = useState("");
         const [blockingNames, setBlockingNames] = useState([]);
         const [deleting, setDeleting] = useState(false);
         const [deleteTarget, setDeleteTarget] = useState(null);
         
         // open confirm dialog
         const onClickDelete = (item) => {
           setDeleteTarget(item);
           setConfirmOpen(true);
         };
         
         // confirm deletion -> call API
         const confirmDeleteNow = async () => {
           if (!deleteTarget) return;
           setDeleting(true);
         
           try {
             const res = await instance2.delete(`kitchen/${deleteTarget.id}`);
         
             // prefer backend status field if present
             const httpStatus = res?.status;
         
             if (httpStatus === "OK" || httpStatus === 200) {
               // ✅ success
               setConfirmOpen(false);
               setResultTitle("Sukses");
               setResultMsg("Data telah terhapus.");
               setBlockingNames([]);
               setResultOpen(true);
               fetchKitchenData(); // Refresh table
               return;
             }
         
             // Non-OK but not thrown (rare): treat as blocked/error payload
             const raw = Array.isArray(res?.data?.data)
               ? res.data.data
               : Array.isArray(res?.data)
               ? res.data
               : [];
             const names = raw.map((x) => x?.name).filter(Boolean);
         
             setConfirmOpen(false);
             setResultTitle("Tidak Bisa Dihapus");
             setResultMsg("Mohon hapus data MAKANAN di bawah terlebih dahulu:");
             setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
             setResultOpen(true);
           } catch (e) {
             const httpStatus = e?.response?.status;
             const apiStatus  = e?.response?.data?.status;
         
             // 🔴 500 (or backend status "ERROR"): show blocker dialog + names list
             if (httpStatus === 500 || apiStatus === "ERROR") {
               const raw = Array.isArray(e?.response?.data?.data)
                 ? e.response.data.data
                 : Array.isArray(e?.response?.data)
                 ? e.response.data
                 : [];
               const names = raw.map((x) => x?.name).filter(Boolean);
         
               setConfirmOpen(false);
               setResultTitle("Tidak Bisa Dihapus");
               setResultMsg("Mohon hapus data di bawah terlebih dahulu:");
               setBlockingNames(names.length ? names : ["(Tidak ada rincian)"]);
               setResultOpen(true);
             } else {
               // generic/unexpected error
               setConfirmOpen(false);
               setResultTitle("Gagal");
               setResultMsg(e?.response?.data?.message || "Terjadi kesalahan. Coba lagi.");
               setBlockingNames([]);
               setResultOpen(true);
             }
           } finally {
             setDeleting(false);
             setDeleteTarget(null);
           }
         };

  return (
    
    <div className="p-4">
       

<div className="flex flex-col items-start md:flex-row lg:flex-row md:items-center lg:items-center justify-between">
                      {/* <div className="bg-white p-2 rounded-full cursor-pointer"
                          onClick={() => window.history.back()}>
                      <BackButton 
                      className="rotate-180 text-black" />
                      </div> */}
        <h2 className="block text-black text-xl sm:text-2xl my-2 font-medium">Daftar Dapur</h2><button
          type="button"
          onClick={() => navigate('/tambahdapur')}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Dapur
        </button>
    </div>
    
           {/* Search Bar */}
                    <div className="flex py-4 rounded-[50px] flex-row justify-start items-center gap-2">
                      <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center justify-start">
                        <MagnificationLogo className="h-6 w-6"/>
                        <VerticalLine className="mx-1" />
                        <input
                          type="text"
                          placeholder="Cari nama dapur"
                          className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                          style={{
                            width: `${"Cari nama dapursss".length}ch`,
                          }}
                          value={searchQuery} // Controlled input
                          onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                        />
                      </div>
                    </div>
    
      <table className="table-fixed w-full border-collapse text-left">
        <thead>
          <tr className="bg-white">
            <th
              className="w-[50px] border-b border-gray-300 px-4 py-2 rounded-tl-[15px] text-center text-xxs md:text-xxs lg:text-base"
            >
              No
            </th>
            {roleId === 1 ? (
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('location_name')}
            >
              Koperasi{' '}
              <span className="float-right">{getSortArrow('location_name')}</span>
            </th>
            ) : ("")} 
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('kitchen_name')}
            >
              Nama Dapur{' '}
              <span className="float-right">{getSortArrow('kitchen_name')}</span>
            </th>
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer text-right text-xxs md:text-xxs lg:text-base"
              onClick={() => handleSort('kitchen_pack')}
            >
              Porsi (proposal){' '}
              <span className="float-right">{getSortArrow('kitchen_pack')}</span>
            </th>
            {/* <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer"
              onClick={() => handleSort('description')}
            >
              Deskripsi <span className="float-right">{getSortArrow('description')}</span>
            </th> */}
            <th
              className="border-b border-gray-300 px-4 py-2 cursor-pointer rounded-tr-[15px] text-xxs md:text-xxs lg:text-base text-center"
            >
              Aksi
            </th>
          </tr>
        </thead>
        <tbody>
                  {[
            ...paginatedData,
            ...Array.from({ length: itemsPerPage - paginatedData.length }).map((_, index) => ({
              empty: true, // Add an "empty" object for invisible rows
            })),
          ].map((item, index) => (
            <tr
            key={ item.id}
            className={`hover:bg-gray-200 ${
              index % 2 === 0 ? "bg-bg-gray-100" : "bg-white"
            } ${item.empty ? "invisible border-b border-transparent" : "border-b border-gray-300"}`}
          >
      <td className="w-[50px]px-4 py-2 text-right pe-2 text-xxs md:text-xxs lg:text-base">
      {index + 1 + (currentPage - 1) * itemsPerPage}.</td>
      {roleId === 1 ? (<td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.location_name}</td>) : ("")}
      <td className="px-4 py-2 text-xxs md:text-xxs lg:text-base">{item.kitchen_name || item.name}</td>
      <td className="px-4 py-2 pe-10 text-right text-xxs md:text-xxs lg:text-base">{formatNumber(item.kitchen_pack) || formatNumber(item.kitchen_pack)}</td>
      {/* <td className="border-b border-gray-300 px-4 py-2">{item.description}</td> */}
        <td className="px-4 py-2 text-center text-xxs md:text-xxs lg:text-base">
        <div className="flex justify-center items-center gap-2">
          <button
            className="text-gray-500 p-2 rounded hover:bg-blue-400"
            onClick={() => handleEditClick(item)}
          >
            <EditIcon className="w-5 h-5" />
          </button>
          <button
            className="text-gray-500 p-2 rounded hover:bg-red-400"
            onClick={() => onClickDelete(item)}
          >
            <TrashIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  ))}
</tbody>
      </table>  
      
{/* Pagination Controls */}
<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>

{/* Edit Modal */}
      {isModalOpen && (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
        <div className="bg-white p-4 rounded-lg w-2/3 sm:w-1/3  md:w-1/3 ">
          <h2 className="text-lg font-bold mb-4">Ubah Data Dapur</h2>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Nama Dapur</label>
            <input
              type="text"
              name="kitchen_name"
              value={editRowData.kitchen_name || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Nama Kepala SPPG</label>
            <input
              type="text"
              name="kitchen_head"
              value={editRowData.kitchen_head || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Nomor Telepon Kepala SPPG</label>
            <input
              type="tel"
              name="phone"
              value={editRowData.phone || ""}
              onChange={handleModalChange}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9\-\+\(\)\s]/g, "");
              }}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Alamat</label>
            <input
              type="text"
              name="address"
              value={editRowData.address || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
            />
          </div>
          {/* <div className="mb-4 relative" ref={dropdownRef}>
            <label className="block text-gray-700 mb-2">Koperasi</label>
            <input
              type="text"
              placeholder="Pilih koperasi"
              value={modalSearchTerm}
              onChange={(e) => setModalSearchTerm(e.target.value)}
              onFocus={() => setIsDropdownModalOpen(true)}
              className="w-full px-3 border-none rounded-full bg-white text-xs py-4 focus:outline-none"
            />
            {isDropdownModalOpen && (
              <div className="absolute z-10 bg-white border rounded-lg w-full max-h-40 overflow-y-auto shadow-lg mt-1">
                {modalFilteredLocations.length > 0 ? (
                  modalFilteredLocations.map((loc) => (
                    <div
                      key={loc.id}
                      className="px-4 py-2 text-sm cursor-pointer hover:bg-gray-100"
                      onClick={() => {
                        setEditRowData({ ...editRowData, location_id: loc.id });
                        setModalSearchTerm(loc.name);
                        setIsDropdownModalOpen(false);
                      }}
                    >
                      {loc.name}
                    </div>
                  ))
                ) : (
                  <div className="px-4 py-2 text-sm text-gray-500">
                    No locations found
                  </div>
                )}
              </div>
            )}
          </div> */}
          
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Jumlah Siswa</label>
            <input
              type="text"
              name="kitchen_pack"
              value={formatNumber(editRowData.kitchen_pack) || ""}
              onChange={handleModalChange}
              className="w-full px-3 border-none rounded-md bg-gray-100 py-2"
              disabled
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 mb-2">Deskripsi</label>
            <textarea
              name="description"
              value={editRowData.description || ""}
              onChange={handleModalChange}
              className="w-full px-3 py-2 border rounded-md bg-gray-100"
            ></textarea>
          </div>
          <div className="flex justify-end gap-2">
            <button
              className="px-4 py-2 bg-gray-300 text-black rounded hover:bg-gray-400"
              onClick={() => setIsModalOpen(false)}
            >
              Batal
            </button>
            <button
              className="px-4 py-2 bg-merah-no text-white rounded hover:bg-merah-hover"
              onClick={handleUpdate}
            >
              Simpan
            </button>
          </div>
        </div>
      </div>
    )}
    {/* Confirm dialog delete */}
  <Dialog open={confirmOpen} onOpenChange={setConfirmOpen}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Konfirmasi Hapus</DialogTitle>
        <DialogDescription>
          Hapus <b>{deleteTarget?.kitchen_name || deleteTarget?.name || "item ini"}</b>? Tindakan tidak dapat dibatalkan.
        </DialogDescription>
      </DialogHeader>
  
      <DialogFooter className="gap-2">
        <button
          type="button"
          className="px-4 py-2 rounded"
          onClick={() => setConfirmOpen(false)}
          disabled={deleting}
        >
          Batal
        </button>
        <button
          type="button"
          className="px-4 py-2 rounded bg-merah-no hover:bg-merah-hover text-white disabled:opacity-60"
          onClick={confirmDeleteNow}
          disabled={deleting}
        >
          {deleting ? "Menghapus..." : "Ya, Hapus"}
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  
  {/* Result / Info dialog */}
  <Dialog open={resultOpen} onOpenChange={setResultOpen}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>{resultTitle}</DialogTitle>
        <DialogDescription>{resultMsg}</DialogDescription>
      </DialogHeader>
  
      {blockingNames.length > 0 && (
        <div className="mt-3 text-sm">
          <ul className="list-disc pl-5 space-y-1">
            {blockingNames.map((n, i) => (
              <li key={`${n}-${i}`}>{n}</li>
            ))}
          </ul>
        </div>
      )}
  
      <DialogFooter>
        <button
          type="button"
          className="px-4 py-2 rounded bg-gray-200"
          onClick={() => setResultOpen(false)}
        >
          Tutup
        </button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
  </div>
  );
}
